import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=167710d5&scoped=true"
import script from "./CreateGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167710d5",
  null
  
)

export default component.exports